import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';

import type {
  CatalogoPermissoesDto,
  PermissoesDoUsuarioDto,
  PermissoesSalvasDto,
  SecretariaMember,
  SecretariaPermissionGroup,
  UsuariosEquipeInternaPaginaDto,
} from '../../types/secretariaPermissions';
import { mapCatalogoToGroups, mapUsuarioToMember } from '../../utils/secretariaPermissions';

const BASE_URL = '/admin/equipe-interna';

/**
 * A lista é a busca da equipe interna que já existe em `/admin/arbitral/usuarios`, no escopo do
 * painel: toda SECRETARIA e só os ADMIN que são admin da Secretaria (decisão de 26/10: Brenno e
 * Daniel); os demais ADMIN da plataforma ficam fora. A busca e a ordenação do painel são locais,
 * então a lista precisa vir inteira: pede páginas de 100 (o teto da rota) até a última.
 */
const LISTA_URL = '/admin/arbitral/usuarios?escopo=painel-permissoes&ativo=true&limit=100';

export const secretariaPermissionsService = {
  async fetchCatalogo(): Promise<SecretariaPermissionGroup[]> {
    const response = await apiGet(`${BASE_URL}/permissoes/catalogo`);
    return mapCatalogoToGroups(await parseApiResponse<CatalogoPermissoesDto>(response));
  },

  async fetchMembros(): Promise<SecretariaMember[]> {
    const membros: SecretariaMember[] = [];
    for (let page = 1; ; page += 1) {
      const response = await apiGet(`${LISTA_URL}&page=${page}`);
      const pagina = await parseApiResponse<UsuariosEquipeInternaPaginaDto>(response);
      membros.push(...pagina.data.map(mapUsuarioToMember));
      if (page >= pagina.pagination.totalPages) return membros;
    }
  },

  async fetchPermissoes(usuarioId: string): Promise<string[]> {
    const response = await apiGet(`${BASE_URL}/usuarios/${usuarioId}/permissoes`);
    return (await parseApiResponse<PermissoesDoUsuarioDto>(response)).permissoes;
  },

  async salvarPermissoes(usuarioId: string, permissoes: string[]): Promise<string[]> {
    const response = await apiPut(`${BASE_URL}/usuarios/${usuarioId}/permissoes`, { permissoes });
    return (await parseApiResponse<PermissoesSalvasDto>(response)).permissoes;
  },

  async removerMembro(usuarioId: string): Promise<void> {
    const response = await apiPost(`${BASE_URL}/usuarios/${usuarioId}/remover`, {});
    await parseApiResponse<unknown>(response);
  },
};
